import { strings } from "../../localization";
import { Box, ButtonPrimary, Grid, Tag, Text2, TextField, useScreenSize } from "@telefonica/mistica";
import React from "react";
import { formatAmount, parseMoneyToDecimal } from "../../utils/formatters";
import type { PartialAnticipationShelf } from "../../shelves";
import { observer } from "mobx-react-lite";
import { MIN_VALUE_ANTICIPATION } from "../../constants";

interface IProps {
	isLoading?: boolean;
	partialAnticipationShelf: PartialAnticipationShelf;
	onSubmit(): Promise<void>;
	currentComponentControl(): void;
}

export const PartialAnticipationForm: React.FC<IProps> = observer((props) => {
	const { isLoading, onSubmit, partialAnticipationShelf, currentComponentControl } = props;
	const { title, labelInput, helperText, valueNotReached } = strings.components.partialAnticipationForm;
	const { maxFGTSValueAvailable } = strings.components.anticipationSimulation;
	const { isDesktopOrBigger } = useScreenSize();

	const valueAnticipation = parseMoneyToDecimal(partialAnticipationShelf.selectedFGTSAnticipationValue.value);
	const isValueInputError =
		valueAnticipation < MIN_VALUE_ANTICIPATION ||
		valueAnticipation > partialAnticipationShelf.maxFGTSValueAvailable.value;

	const minimumValueNotReached = partialAnticipationShelf.maxFGTSValueAvailable.value < MIN_VALUE_ANTICIPATION;

	return (
		<Grid gap={16}>
			<Box
				className={`${isDesktopOrBigger ? "center-aligned" : "children-full-width text-align-center"}`}
				paddingTop={24}
			>
				<Tag type="active">
					{maxFGTSValueAvailable + formatAmount(partialAnticipationShelf.maxFGTSValueAvailable.value)}
				</Tag>
			</Box>
			<Text2 medium textAlign="center">
				{title}
			</Text2>
			<TextField
				label={labelInput}
				name="value-antecipation"
				error={partialAnticipationShelf.selectedFGTSAnticipationValue.value !== "" && isValueInputError}
				value={partialAnticipationShelf.selectedFGTSAnticipationValue.value}
				onChange={(e) => {
					partialAnticipationShelf.selectedFGTSAnticipationValue.set(formatAmount(parseMoneyToDecimal(e.target.value)));
					currentComponentControl();
				}}
				helperText={!minimumValueNotReached
					? helperText + formatAmount(partialAnticipationShelf.maxFGTSValueAvailable.value)
					: valueNotReached
				}
				data-cs-mask
			/>
			<Box paddingTop={8}>
				<ButtonPrimary
					showSpinner={isLoading}
					disabled={isValueInputError || isLoading}
					onPress={onSubmit}
					className="button-full-width"
				>
					{strings.components.buttons.simulate}
				</ButtonPrimary>
			</Box>
		</Grid>
	);
});
